import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubEvents = async (pub_id) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/events/${pub_id}?event_state=1`);
    return data;
};
export const getPubEventsByDate = async (pub_id, date) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/events/${pub_id}/by-date?date=${date}`);
    return data;
};
export const usePubEvents = (pub_id) => {
    return useQuery([`pub_events${pub_id}`, pub_id], () => getPubEvents(pub_id));
};
export const usePubEventsByDate = (pub_id, date) => {
    return useQuery([`pub_events_by_date${pub_id}`, pub_id, date], () => getPubEventsByDate(pub_id, date), {
        enabled: !!pub_id && !!date,
    });
};
